import type { QueryClient } from "@tanstack/react-query";

import { ACTIVATION_METADATA } from "app/pages/activation/queries/data/useActivationMetadataQuery";
import type { ActivationMetadata } from "app/pages/activation/types/api";

type UpdateBooleanInActivationItemSchema = {
    itemId: string;
    queryClient: QueryClient;
    objectKey: string;
    value?: boolean;
    resetOther?: boolean;
};

export const updateBooleanInActivationMetadata = ({
    itemId,
    objectKey,
    value,
    queryClient,
    resetOther,
}: UpdateBooleanInActivationItemSchema) => {
    const data: ActivationMetadata = queryClient.getQueryData([ACTIVATION_METADATA]);

    if (!data) {
        return;
    }

    const updatedItems = data.activations.map((item) => {
        if (item.id === itemId) {
            return { ...item, [objectKey]: value ?? !item[objectKey] };
        }

        return resetOther ? { ...item, [objectKey]: false } : item;
    });

    queryClient.setQueryData([ACTIVATION_METADATA], {
        ...data,
        activations: updatedItems,
        manuallyUpdated: true,
    });
};
